import axios from 'axios';
import qs from 'qs';

const getAuth = (isToken) => {
  if (isToken) {
    const token = localStorage.getItem('id_token');
    const accessToken = localStorage.getItem('access_token');
    return { Authorization: `Bearer ${token || accessToken}` };
  }
  return {};
};
const apiCall = ({
  type,
  body,
  headers,
  url,
  isToken,
  params,
  responseType,
  isParamsSerializer,
}) => {
  const auth = getAuth(isToken);
  const paramsSerializer = isParamsSerializer ? {
    paramsSerializer: {
      serialize: (par) => qs.stringify(par, { encode: isParamsSerializer }),
    },
  } : {};
  return axios({
    url,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
      ...(auth || {}),
    },
    data: body,
    method: type,
    params,
    responseType,
    ...paramsSerializer,
  });
};

export default apiCall;
